import React, { useState, ReactNode, CSSProperties } from 'react';

interface AccordionStyles {
  accordionContainer?: string;
  accordionHeader?: string;
  accordionContent?: string;
  headerStyle?: CSSProperties;
  contentStyle?: CSSProperties;
}

interface SimpleAccordionProps {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  styles?: AccordionStyles;
}

const SimpleAccordion: React.FC<SimpleAccordionProps> = ({ 
  title, 
  children, 
  defaultOpen = false, 
  styles = {} 
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(defaultOpen);

  // Toggle accordion visibility
  const toggleAccordion = (): void => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={styles.accordionContainer || 'accordion-container'}  style={{marginTop:'12px'}}>
      <button 
        className={styles.accordionHeader || 'accordion-header'}
        onClick={toggleAccordion}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          padding: '8px 12px',
          backgroundColor: '#333',
          color: 'white',
          border: 'none',
          textAlign: 'left',
          cursor: 'pointer',
          borderRadius: isOpen ? '4px 4px 0 0' : '4px',
          ...styles.headerStyle
        }}
      >
        <span>{title}</span>
        <span>{isOpen ? '▼' : '▶'}</span>
      </button>
      
      {isOpen && (
        <div 
          className={styles.accordionContent || 'accordion-content'}
          style={{
            padding: '8px',
            border: '1px solid #444',
            borderTop: 'none',
            borderRadius: '0 0 4px 4px',
            ...styles.contentStyle
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default SimpleAccordion;